// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"287":"f9384887","422":"84c5ec3e","454":"d0973d67"}[chunkId] + ".chunk.js";
};